import React, { ReactNode } from 'react';
import { Stack, type SxProps, type Theme } from '@mui/material';

type BaseCellProps = { children?: ReactNode; minWidth?: number; sx?: SxProps<Theme> };

const BaseCell = ({ children, minWidth = 168, sx }: BaseCellProps) => (
  <Stack gap={1.25} minWidth={minWidth} direction="row" alignItems="center" p={2} sx={sx}>
    {children}
  </Stack>
);
export default BaseCell;
